import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NotifyActivated from "./pages/NotifyActivated/NotifyActivated";
import Unsubscribe from "./pages/Unsubscribe/Unsubscribe";
import AppLayout from "./App";
import SubscriptionPage from "./pages/Subscription/Subscription";
// import WelcomePage from './WelcomePage';
// import NotFoundPage from './NotFoundPage';

function AppRouter() {
  return (
    <Router basename={process.env.PUBLIC_URL || "/"}>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index path="/" element={<SubscriptionPage />} />
          <Route path="notify-activated" element={<NotifyActivated />} />
          <Route path="unsubscribe" element={<Unsubscribe />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRouter;
